import { useMemo } from 'react';
import { AiGenerationLock, resolveAiGenerationLock } from '@/components/wizard/ai-generation-lock';
import { useReportWizard } from '@/pages/create-report/context/ReportWizardContext';

/**
 * Reads the single-flight AI lock from the wizard on behalf of one section.
 *
 * The memo is load-bearing rather than decorative: the context hands every
 * consumer a fresh object literal on each keystroke in the document, so an
 * unmemoised reason string would be a new value on every keypress and churn the
 * props of whatever button it feeds.
 */
export function useAiGenerationLock(ownerId?: string): AiGenerationLock {
    const { isGenerating, generatingSectionId, sidebarSteps } = useReportWizard();

    return useMemo(
        () =>
            resolveAiGenerationLock({
                isGenerating,
                generatingSectionId,
                sidebarSteps,
                ownerId,
            }),
        [isGenerating, generatingSectionId, sidebarSteps, ownerId],
    );
}
